module.exports = __webpack_public_path__ + "static/media/45.324e3c71.jpg";